import { Component, ElementRef, ViewChild, OnInit, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { CoopServiceService } from '../../../services/Coop/coop-service.service';
import { ViewerService } from '../../../services/Viewer/viewer.service';
import { registerLocaleData } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";
import he from '@angular/common/locales/he';
import { Router } from '@angular/router';
import { callable } from 'src/app/components/callable';

@Component({
  selector: 'app-coop-machine',
  templateUrl: './coop-machine.component.html',
  styleUrls: ['./coop-machine.component.scss']
})
export class CoopMachineComponent implements OnInit {

  constructor(
    private CoopServiceService: CoopServiceService,
    private SpinnerService: NgxSpinnerService,
    private ViewerService: ViewerService,
    private router: Router
  ) { }

  searchText: any;
  year_now: any;
  datayear: any;
  TypeCoop: any;
  TypeAgri: any;
  CoopMachineYear: any;
  PurchaseYear: any;
  sumResult: any;
  check_Nodata: any;
  AgriMachineYear: any;
  sumResult_: any;
  check_Nodata_: any;
  Agri
  pageOfItems: Array<any>;


  PhakId: any
  orgid: any
  KhetId: any
  KhetId_: any
  PhakByKhet: any
  ProvinceByKhet: any
  PhakList: any
  groupkhet_bkk1: any
  groupkhet_bkk2: any
  groupkhet_1: any
  checkkhet: any
  show: any = false
  viewer: any;

  ngOnInit(): void {
    // this.verify_role();
    this.year_now = callable.getCurrentYear();
    this.datayear = this.year_now;
    this.Agri = true;
    this.TypeCoop = true;
    localStorage.setItem("Agri", this.Agri);

    this.GetPhakList();
    this.GetKhetList();

    registerLocaleData(he);

  }

  verify_role(){
    let user = JSON.parse(localStorage.getItem("access_token"));
    if(user && user['role'] == 'Admin'){
      this.router.navigate(["/user-management"]);
    }
  }

  select_TypeAgri(data) {
    this.TypeAgri = data;
    if (this.TypeAgri == "TypeAgri") {
      this.TypeAgri = true;
      this.TypeCoop = false;
    }

  }

  select_TypeCoop(data) {
    this.TypeCoop = data;
    if (this.TypeCoop == "TypeCoop") {
      this.TypeCoop = true;
      this.TypeAgri = false;
    }

  }

  setphak(event) {
    this.PhakId = event;
    this.orgid = "null";
    this.KhetId = "null";

    this.GetKhetList();

  }

  setkhet(event) {
    this.KhetId = event;
    this.KhetId_ = this.KhetId;
    this.PhakId = "null";
    this.orgid = "null";
    this.CoopServiceService.GetPhakByKhet(this.KhetId).subscribe(res => {
      this.PhakByKhet = res;
    });

    this.GetProvinceByKhet();

  }

  setProvince(event) {
    this.orgid = event;
    this.KhetId = "null";
    this.PhakId = "null";
  }

  GetPhakList() {
    this.SpinnerService.show();
    this.ProvinceByKhet = null;
    this.CoopServiceService.GetPhakList().subscribe(res => {
      this.PhakList = res;
      this.SpinnerService.hide();

    });

  }

  GetProvinceByKhet() {
    this.CoopServiceService.GetProvinceByKhet(this.KhetId_).subscribe(res => {
      this.ProvinceByKhet = res;
    });
  }


  GetKhetList() {
    this.ProvinceByKhet = null;
    this.CoopServiceService.GetKhetList().subscribe(res => {
      // this.checkkhet = res;

      for (let i = 0; i < res.length; i++) {

        if (this.PhakId == 1) {
          this.groupkhet_bkk1 = 'true';
          this.groupkhet_bkk2 = 'true';
          this.checkkhet = [
            { "khet_desc": res[18].khet_desc, "khet_id": res[18].khet_id },
            { "khet_desc": res[19].khet_desc, "khet_id": res[19].khet_id },
          ]
        }
        else if (this.PhakId == 2) {
          this.groupkhet_1 = 'true';
          this.checkkhet = [
            { "khet_desc": res[14].khet_desc, "khet_id": res[14].khet_id },
            { "khet_desc": res[15].khet_desc, "khet_id": res[15].khet_id },
            { "khet_desc": res[16].khet_desc, "khet_id": res[16].khet_id },
            { "khet_desc": res[17].khet_desc, "khet_id": res[17].khet_id },
          ]
        }
        else if (this.PhakId == 3) {
          this.checkkhet = [
            { "khet_desc": res[0].khet_desc, "khet_id": res[0].khet_id },
            { "khet_desc": res[1].khet_desc, "khet_id": res[1].khet_id },
            { "khet_desc": res[2].khet_desc, "khet_id": res[2].khet_id },
            { "khet_desc": res[3].khet_desc, "khet_id": res[3].khet_id },
            { "khet_desc": res[7].khet_desc, "khet_id": res[7].khet_id },
            { "khet_desc": res[8].khet_desc, "khet_id": res[8].khet_id },
          ]
        }
        else if (this.PhakId == 4) {
          this.checkkhet = [
            { "khet_desc": res[9].khet_desc, "khet_id": res[9].khet_id },
            { "khet_desc": res[10].khet_desc, "khet_id": res[10].khet_id },
            { "khet_desc": res[11].khet_desc, "khet_id": res[11].khet_id },
            { "khet_desc": res[12].khet_desc, "khet_id": res[12].khet_id },
            { "khet_desc": res[13].khet_desc, "khet_id": res[13].khet_id },
          ]
        }
        else if (this.PhakId == 5) {
          this.checkkhet = [
            { "khet_desc": res[4].khet_desc, "khet_id": res[4].khet_id },
            { "khet_desc": res[5].khet_desc, "khet_id": res[5].khet_id },
            { "khet_desc": res[6].khet_desc, "khet_id": res[6].khet_id }
          ]
        }
      }

    });
  }

  Search() {
    if (this.orgid == undefined && this.PhakId == undefined && this.KhetId == undefined) {
      this.orgid = "null";
      this.PhakId = "null";
      this.KhetId = "null";
    }

    this.SpinnerService.show();
    this.GetCoopMachineSumDesc();
    this.SpinnerService.hide();

  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  get_viewer() {
    let count;
    this.ViewerService.Get_viewerAll('Machine').subscribe(
      responce => {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount(responce[0].id, count).subscribe(
          responce => {
          }
        )
      }
    );
  }

  GetCoopMachineSumDesc() {
    this.AgriMachineYear = null;
    this.CoopServiceService.GetCoopMachineSumDesc(this.orgid, this.PhakId, this.KhetId).subscribe(res => {
      // this.CoopMachineYear = res;

      this.CoopMachineYear = Array(res.length).fill(0).map((x, i) => ({
        assetDesc: res[i].assetDesc, canUse: res[i].canUse, canNotUse: res[i].canNotUse
        , qtyUom: res[i].qtyUom
      }));

      this.sumResult = res.length;

      if (this.sumResult == 0) {
        this.check_Nodata = true;
      } else {
        this.check_Nodata = false;
      }

      this.get_viewer();
    })
  }

}
